export default {
  AUTO: 'auto',
  BOTTOM: 'bottom',
  TOP: 'top',
};
